import styled from 'styled-components'
import variables, { colors } from 'Styled/variables'

export const ModalBody = styled.div`
  padding: 32px 100px 32px 100px;
  height: 638px;
  overflow-y: scroll;
`

export const ModalBodySmall = styled.div`
  padding: 32px 100px 32px 100px;
`

export const ModalBodyTitle = styled.div`
  display: flex;
  margin-bottom: 24px;
`
export const ModalBodyTitleImg = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 4px;
  margin-right: 16px;

  & img {
    border-radius: 4px;
    width: 40px;
    height: 40px;
  }
`
export const ModalBodyTitleText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
export const ModalBodyTitleTextName = styled.a`
  font-size: ${variables.fontSize14};
  font-weight: 400;
  line-height: 21px;
  color: ${colors.mainText};
`

export const ModalBodyTitleTextBy = styled.div`
  font-size: ${variables.fontSize10};
  font-weight: 400;
  line-height: 15px;
  color: ${colors.mainText};
`

export const TitleDetails = styled.div`
  font-size: ${variables.fontSize18};
  font-weight: 400;
  line-height: 27px;
  color: ${colors.mainText};
  margin-bottom: 8px;
`

export const DetailsList = styled.ul`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 0;
  margin: 0px;
`

export const DetailsItem = styled.li`
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-bottom: 8px;
`

export const DetailsItemTitle = styled.div`
  min-width: 170px;
  font-size: ${variables.fontSize14};
  font-weight: 400;
  line-height: 21px;
  color: ${colors.greyTextWhiteBg};
`

export const DetailsItemLink = styled.a`
  font-size: ${variables.fontSize14};
  font-weight: 400;
  line-height: 21px;
  color: ${colors.mainText};
  border-bottom: 1px solid ${colors.mainText};
  &:hover,
  &:focus {
    color: ${colors.mainText};
  }
`

export const DetailsItemInfo = styled.div`
  font-size: ${variables.fontSize14};
  font-weight: 400;
  line-height: 21px;
  color: ${colors.mainText};
`

export const DiscoveredOnWrapper = styled.div`
  margin-bottom: 11px;
`
export const WrapperForStatus = styled.div`
  padding-top: 16px;
`

export const DetailsItemInfoNegative = styled(DetailsItemInfo)`
  color: ${colors.messegesRed};
`
export const DetailsItemInfoSecondary = styled(DetailsItemInfo)`
  color: ${colors.greyTextWhiteBg};
  margin-left: 16px;
`

export const DetailsItemInfoStatus = styled(DetailsItemInfo)`
  color: ${colors.messegesYellow1};
`

export const SFAData = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-bottom: 17.5px;
  padding-top: 16px;
`

export const SFADataTitle = styled.div`
  width: 170px;
  font-size: ${variables.fontSize18};
  font-weight: 400;
  line-height: 27px;
  color: ${colors.mainText};
`
export const ModalFooter = styled.div`
  padding-top: 24px;
  height: 88px;
  width: 100%;
  margin: 0 auto;
  box-shadow: 0px 0px 6px rgb(0 0 0 / 25%);
  position: relative;
  z-index: 101;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-around;
`
export const ShowDetailsWrapper = styled.table`
  width: 100%;
  margin-bottom: 40px;
`
export const List = styled.ul`
  padding: 0;
  list-style-type: none;
  display: inline-flex;
  flex-wrap: wrap;
`

export const Th = styled.th`
  font-size: ${variables.fontSize10};
  font-weight: 400;
  line-height: 15px;
  color: ${colors.greyTextWhiteBg};
`
